import React from 'react';
import PropTypes from 'prop-types';
import isObject from 'lodash.isobject';
import DateTimeDisplay from './DateTimeDisplay';
import { LUXTON_FORMAT_DATE_TIME } from '../helpers/date';
import StatusDisplayWidget from './StatusDisplayWidget';

const CallsWidget = ({ value }) => (
  <div className="">
    {value &&
      Array.isArray(value) &&
      value.length && (
        <table className="table">
          <thead>
            <tr>
              <th>Status</th>
              <th>Agent</th>
              <th>Call Time</th>
              <th>Duration (seconds)</th>
              <th>Subject</th>
              <th>Comment</th>
              <th>Callback Date</th>
            </tr>
          </thead>
          <tbody>
            {value
              .filter(callData => callData && isObject(callData))
              .map(callData => (
                <tr key={`${callData.status}${callData.details.start}`}>
                  <td>{callData.status}</td>
                  <td>{callData.agentUsername}</td>
                  <td>
                    <DateTimeDisplay
                      value={callData.details.start}
                      dateFormat={LUXTON_FORMAT_DATE_TIME}
                    />
                  </td>
                  <td>{callData.details.duration / 1000}</td>
                  <td>{callData.details.subject}</td>
                  <td>{callData.details.comment}</td>
                  <td>
                    <DateTimeDisplay
                      value={callData.details.callbackDate}
                      dateFormat={LUXTON_FORMAT_DATE_TIME}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    {Array.isArray(value) &&
      value.length && (
        <StatusDisplayWidget value={value[value.length - 1].status} />
      )}
  </div>
);

// <div>{JSON.stringify(value || {})}</div>
CallsWidget.propTypes = {
  value: PropTypes.array
};

export default CallsWidget;



// WEBPACK FOOTER //
// ./src/components/CallsWidget.js